<template>
    <AppModal ref="modal" title="Оновити в СРМ">
        <div class="modal-body">
            <template v-if="shouldShowErrorTable">
                <div class="table-responsive table-scrollable">
                    <table class="table table-bordered table-fixed">
                        <thead>
                            <tr>
                                <th>{{ $t('labels.copy_products_request') }}</th>
                                <th>{{ $t('labels.copy_products_response') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="badHttpHistoryItem in badHttpHistory">
                                <td><span class="text-nowrap" :title="badHttpHistoryItem.request.path">{{ badHttpHistoryItem.request.path }}</span></td>
                                <td><span class="text-nowrap" :title="badHttpHistoryItem.response.body">{{ badHttpHistoryItem.response.body }}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template v-else-if="task.state.isRunning">
                <TaskProgressBar :done="task.state.done" :total="task.state.total"/>
            </template>
        </div>
    </AppModal>
</template>
<script>
import AppModal from "../../../../../../../components/new/modal/AppModal.vue";
import TaskProgressBar from "../../../../../../../components/new/progress/TaskProgressBar.vue";

import HttpRequest from "../../../../../../../services/Http/HttpRequest";
import HttpSender from "../../../../../../../services/Http/HttpSender";
import MessageNotificator from "../../../../../../../services/MessageNotificator";
import { createProgressTask } from "../../../../../../../services/Progress/ProgressTask";

export default {
    name: "UpsertIntegrationOrderModal",
    components: {
        AppModal, TaskProgressBar
    },
    data() {
        return {
            task: createProgressTask(),
            orderUuids: [],
            httpSender: new HttpSender(),
            badHttpHistory: []
        }
    },
    methods: {
        show(orderUuids) {
            this.orderUuids = orderUuids;
            this.$refs.modal.show();
            this.upsertOrders();
        },
        hide() {
            this.task.cancel();
            this.$refs.modal.hide();
            this.orderUuids = [];
            this.badHttpHistory = [];
            this.httpSender = new HttpSender();
        },
        async upsertOrders() {
            const requests = this.orderUuids.map(
                orderUuid => new HttpRequest('POST', `/integrations/${this.$route.params.integrationUuid}/orders/${orderUuid}/start-upsert-job`),
            );

            const completed = await this.task.run(async ({setTotal, tick}) => {
                setTotal(requests.length);

                await this.httpSender.sendRequestsInBatches(requests, () => tick());
            });

            if (!completed) {
                return;
            }

            this.badHttpHistory = this.httpSender.getHistory().filter((historyItem) => {
                return historyItem.response.status !== 201 && historyItem.response.status !== 200;
            });

            if (this.badHttpHistory.length === 0) {
                new MessageNotificator().success(this.$t('alerts.success'));
                this.hide();
            }
        }
    },
    computed: {
        shouldShowErrorTable() {
            return !this.task.state.isRunning && this.badHttpHistory.length > 0;
        }
    },
    beforeUnmount() {
        this.task.cancel();
    }
}
</script>
